var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.00001,
    y: 4.99984,
    width: 25,
    height: 25,
    rx: 12.5,
    stroke: "#DC6803",
    strokeWidth: 1.66667
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.833333,
    y: 0.833333,
    width: 33.3333,
    height: 33.3333,
    rx: 16.6667,
    stroke: "#DC6803",
    strokeWidth: 1.66667
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45745_1553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.1665V17.4998M17.5 20.8332H17.5083M25.8333 17.4998C25.8333 22.1022 22.1024 25.8332 17.5 25.8332C12.8976 25.8332 9.16667 22.1022 9.16667 17.4998C9.16667 12.8975 12.8976 9.1665 17.5 9.1665C22.1024 9.1665 25.8333 12.8975 25.8333 17.4998Z",
    stroke: "#DC6803",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45745_1553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleOutlined);
export default __webpack_public_path__ + "static/media/alert-circle-outlined.c62810aed287ef129768a56281e83cef.svg";
export { ForwardRef as ReactComponent };